import FaqCourseIcon from "@svg/access/sidebar/course-types/FaqCourseIcon";
import GlossaryCourseIcon from "@svg/access/sidebar/course-types/GlossaryCourseIcon";
import QuestionCourseIcon from "@svg/access/sidebar/course-types/QuestionCourseIcon";
import RelatedJobsCourseIcon from "@svg/access/sidebar/course-types/RelatedJobs";
import TranscriptCourseIcon from "@svg/access/sidebar/course-types/TranscriptCourseIcon";
import TextAiIcon from "@svg/new-design/text-ai";
import { LESSON_STEP_TYPE } from "@types";

export const TextractorIcon = (
  type: LESSON_STEP_TYPE,
  iconClassName: string
) => {
  return type === LESSON_STEP_TYPE.GLOSSARY ? (
    <GlossaryCourseIcon className={iconClassName} />
  ) : type === LESSON_STEP_TYPE.INTERVIEW_QUESTIONS ? (
    <FaqCourseIcon className={iconClassName} />
  ) : type === LESSON_STEP_TYPE.FAQ ? (
    <QuestionCourseIcon className={iconClassName} />
  ) : type === LESSON_STEP_TYPE.RELATED_JOB ? (
    <RelatedJobsCourseIcon className={iconClassName} />
  ) : type === LESSON_STEP_TYPE.SUMMARY_NOTE ? (
    <TextAiIcon className={iconClassName} />
  ) : null;
};

export const headlineSupplementaryContent = (iconClassName?: string) => ({
  summary_note: {
    label: "خلاصه متنی آموزش",
    icon: <TextAiIcon className={iconClassName ?? ""} />,
  },
  glossary: {
    label: "واژه نامه تخصصی",
    icon: <GlossaryCourseIcon className={iconClassName ?? ""} />,
  },
  faq: {
    label: "پرسش‌های متداول (FAQ)",
    icon: <QuestionCourseIcon className={iconClassName ?? ""} />,
  },
  related_jobs: {
    label: "مشاغل مرتبط",
    icon: <RelatedJobsCourseIcon className={iconClassName ?? ""} />,
  },
  interview_questions: {
    label: "نمونه پرسش‌های مصاحبه شغلی",
    icon: <FaqCourseIcon className={iconClassName ?? ""} />,
  },
});

export const contentSectionSupplementaryContent = (iconClassName?: string) => ({
  summary: {
    label: "خلاصه متنی آموزش",
    icon: <TextAiIcon className={iconClassName ?? ""} />,
  },
  glossary: {
    label: "واژه نامه تخصصی",
    icon: <GlossaryCourseIcon className={iconClassName ?? ""} />,
  },
  related_jobs: {
    label: "مشاغل مرتبط",
    icon: <RelatedJobsCourseIcon className={iconClassName ?? ""} />,
  },
  transcript: {
    label: "زیرنویس فارسی ویدئوها",
    icon: <TranscriptCourseIcon className={iconClassName ?? ""} />,
  },
});
